import type {
  ButtonAsLinkVariant,
  ButtonVariant as PCAButtonVariant,
} from '@property.com.au/ui-kit';

export type ButtonVariant =
  | 'LINK_INLINE'
  | 'LINK_PRIMARY'
  | 'LINK_SECONDARY'
  | 'NAKED'
  | 'OUTLINE'
  | 'OUTLINE_SECONDARY'
  | 'PRIMARY'
  | 'SECONDARY'
  | 'SELECTED';

export const mapButtonVariant = (
  variant: ButtonVariant | undefined | null,
): PCAButtonVariant | ButtonAsLinkVariant => {
  switch (variant) {
    case 'PRIMARY':
      return 'primary';
    case 'SECONDARY':
      return 'secondary';
    case 'OUTLINE':
      return 'outline';
    case 'NAKED':
      return 'naked';
    case 'LINK_PRIMARY':
      return 'link-primary';
    case 'LINK_SECONDARY':
      return 'link-secondary';
    case 'LINK_INLINE':
      return 'link-inline';
    case 'OUTLINE_SECONDARY':
      return 'outline-secondary';
    default:
      return 'primary';
  }
};
